import Component from '@glimmer/component';
import WrButton, {
  type WrButtonSignature
} from '../../../components/button.gts';
import type { HeadlessFormComponentSignature } from 'ember-headless-form/components/headless-form';
import { type UserData } from '../../types.ts';

export interface Signature<DATA extends UserData> {
  Element: HTMLButtonElement;
  Args: WrButtonSignature['Args'] & {
    isDisabled?: boolean;
    form: HeadlessFormComponentSignature<DATA, unknown>['Blocks']['default'][0];
  };
  Blocks: { default: [] };
}

export default class WrFormSubmitButtonComponent<
  DATA extends UserData
> extends Component<Signature<DATA>> {
  get isDisabled() {
    return (
      this.args.isDisabled ||
      this.args.form.isInvalid ||
      this.args.form.submissionState?.isPending
    );
  }

  <template>
    <WrButton
      @variant={{@variant}}
      @icon={{@icon}}
      type='submit'
      disabled={{this.isDisabled}}
      {{!
        For Forc::Provider compatibility in tests
        The paradigm click("[data-test-next-button]") in our tests is very widely used

        For the time being, let's just use the same data-test attr in WrForm
        to easily make our tests Wiser compatible
      }}
      data-test-next-button
      ...attributes
    >{{yield}}</WrButton>
  </template>
}
